"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = componentSubstitution;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _markdown = _interopRequireDefault(require("../../markdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Substitutes components in to a text string replacing {{macro|value}} with a React
 * render function. Same as stringSubstitution, but with components.
 *
 * Use Cases:
 * - render React components in place of strings.
 * - render a *bold* string in place of the macro text
 * - give the macro text a color
 * @param {string} text - text that may or may not contain {{macro|value}} entries
 * @param {object} components - Mapping of macros to functional components.
 *                              Fn is passed macro or macro value
 * @param {object} [options] - Options for the substitution.
 * @param {bool} [options.markdown] - Use markdown for the text fragments. Default is true.
 * @param {string} [options.markdownWrapperElement] - Element used to wrap markdown.
 * @param {object} [options.remarkableOptions] - Options passed to remarkable.
 */
function componentSubstitution(text, components) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    markdown: true,
    remarkableOptions: {}
  };

  if (typeof text !== 'string') {
    return '';
  } // Regex to extract macros.


  var split = text.split(/{{([^{}]+)}}/g);
  return split.map(function (macro, index) {
    if (macro.length < 1) {
      return null;
    }

    var _macro$split = macro.split('|'),
        _macro$split2 = _slicedToArray(_macro$split, 2),
        macroKey = _macro$split2[0],
        macroValue = _macro$split2[1];

    var render = components[macroKey];
    var value = macroValue || macroKey;
    var fragment;

    if (_lodash["default"].isFunction(render)) {
      fragment = render(value);
    } else {
      fragment = options.markdown ? /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
        element: options.markdownWrapperElement,
        options: _objectSpread({
          html: true,
          breaks: true
        }, options.remarkableOptions),
        source: macro
      }) : macro;
    } // eslint-disable-next-line react/no-array-index-key


    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "".concat(index, "\u2013").concat(macro)
    }, fragment);
  });
}